// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_PIO","cls2":"SearchBox-cls2_8bN SearchBox-cls1_PIO"};